// form_success.js
import React from 'react';

function Form_success() {
  return (
    <div style={styles.container}>
      <h1>Form Submitted Successfully!</h1>
      <p>Thank you for your submission.</p>
      <a href="/" style={styles.link}>Go Home</a>
    </div>
  );
}

export default Form_success;

const styles = {
  container: {
    maxWidth: '400px',
    margin: '2rem auto',
    padding: '1rem',
    backgroundColor: '#f8f8f8',
    borderRadius: '8px',
    textAlign: 'center',
  },
  link: {
    color: '#2a9d8f',
    textDecoration: 'underline',
  },
};
